import { configureStore } from "@reduxjs/toolkit";
import { todoApiSlice } from "../features/api/apiSlice";
import { filterReducer } from "../features/filter/filterSlice";

const store = configureStore({
  reducer: {
    [todoApiSlice.reducerPath]: todoApiSlice.reducer,
    filter: filterReducer,
  },
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(todoApiSlice.middleware),
});

export default store;
